import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";

export const getSharedFileRequirementTitle = (
  requirement: IRequirementResponse,
  context: ContextItem,
  sharedFile: ISharedFileRequestResponse | undefined
): string => {
  if (!requirement.dataSourceId) {
    return "File not uploaded";
  }

  return sharedFile?.title || "--";
};
